function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($helpers) {
    var h = require("panel").h;
    return {
      value: (h("div", {
        "class": {
          'mp-query-sampling-cta': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-query-sampling-cta-title': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat("Use query sampling to get results faster");;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("mp-button", {
          "on": {
            click: $helpers.enableQuerySampling
          },
          "attrs": {
            theme: `secondary`,
            icon: `sampling`,
            size: `small`
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat("Re-run with query time sampling");;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;